import * as Api from '@ViewModels';
import { StyleDeclarationValue } from 'aphrodite';
import { Provider, observer } from 'mobx-react';
import * as React from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import { IImpersonationContextComponentProps } from '../../../../models';
import { MastheadPortalId } from '../../../../models/AdminModels';
import { useAdminAccountQuery } from '../../../../queries';
import { ImpersonationContextViewModel } from '../../../../viewmodels/AdminViewModels';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../../../web/components/Breadcrumb';
import { MultiContainerHeader } from '../../../../web/components/MultiContainerHeader';
import { CreateAutomationTemplatePage } from '../../../../web/containers/CreateAutomationTemplate';
import { INavigationItemProps } from '../../../../web/containers/MainContainer';

interface IProps extends INavigationItemProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

const CreateAccountAutomationTemplateFc: React.FC<IProps> = props => {
	const history = useHistory();
	const params = useParams<{ id?: string }>();
	const mImpersonationProviderProps: IImpersonationContextComponentProps = React.useRef({
		impersonationContext: new ImpersonationContextViewModel(params?.id ? { account: { id: params.id } } : undefined),
	}).current;
	const accountQuery = useAdminAccountQuery({ accountId: params.id });
	const companyName = accountQuery.data?.companyName;

	const onRequestEdit = React.useCallback(
		(automationTemplate: Api.AutomationTemplateViewModel) => {
			history.replace(`/accounts/${params.id}/automations/${automationTemplate.id}`);
			return true;
		},
		[history, params]
	);

	return (
		<Provider {...mImpersonationProviderProps}>
			<MultiContainerHeader
				appBarHeader={
					<Breadcrumb>
						<BreadcrumbList>
							<BreadcrumbItem>
								<BreadcrumbLink asChild>
									<NavLink to='/accounts'>Accounts</NavLink>
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator />
							<BreadcrumbItem>
								<BreadcrumbLink asChild>
									<NavLink to={`/accounts/${params.id}?tab=Automations`}>{companyName ?? 'Loading...'}</NavLink>
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator />
							<BreadcrumbItem>
								<BreadcrumbPage>New Automation</BreadcrumbPage>
							</BreadcrumbItem>
						</BreadcrumbList>
					</Breadcrumb>
				}
				appBarPortalDestinationId={MastheadPortalId}
			/>
			<CreateAutomationTemplatePage {...props} impersonationAccountId={params?.id} onRequestEdit={onRequestEdit} />
		</Provider>
	);
};

export const CreateAccountAutomationTemplate = observer(CreateAccountAutomationTemplateFc);
